export default __webpack_public_path__ + "static/media/chevron-left.9c8493b7.svg";